import * as IoC from 'inversify';
import { registerQuery, registerCommand } from '@/app/tracking/common';
import * as Projection from '../projection'
import { UpdateBookmarkTrackingCommandName, QueryBookmarkTrackingQueryName } from '../api';
import { UpdateBookmarkTrackingCommandHandler } from './update-bookmark-tracking-command-handler';
import { QueryBookmarkTrackingQueryHandler } from './query-bookmark-tracking-query-handler';

export const bookmarkCommonTrackingModule = new IoC.ContainerModule((bind) => {
  bind(Projection.BookmarkStateProjection).toSelf().inSingletonScope();
  registerCommand(UpdateBookmarkTrackingCommandName,
                  UpdateBookmarkTrackingCommandHandler, bind);
  registerQuery(QueryBookmarkTrackingQueryName,
                QueryBookmarkTrackingQueryHandler, bind);
})
